import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import * as bootstrap from 'bootstrap';
import './theme.css'; 

function showToast(message) {
  let toastContainer = document.getElementById('global-toast');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'global-toast';
    document.body.appendChild(toastContainer);
  }

  const toastEl = document.createElement('div');
  toastEl.className = 'toast align-items-center text-bg-danger border-0';
  toastEl.setAttribute('role', 'alert');
  toastEl.setAttribute('aria-live', 'assertive');
  toastEl.setAttribute('aria-atomic', 'true');

  toastEl.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">${message}</div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

  toastContainer.appendChild(toastEl);
  new bootstrap.Toast(toastEl, { delay: 5000 }).show();
}

const api = axios.create({
  baseURL: 'http://localhost:3000/api',
});

let isLoggingOut = false;

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && !isLoggingOut) {
      isLoggingOut = true;

      sessionStorage.removeItem('token');

      showToast('Your session has expired. Please log in again.');

      router.push('/login').finally(() => {
        isLoggingOut = false;
      });

      return Promise.resolve(null);
    }

    return Promise.reject(error);
  }
);

function startSessionTimer() {
  setTimeout(() => {
    sessionStorage.removeItem('token');
    showToast('Your session has expired. Please log in again.');
    router.push('/login');
  }, 30 * 1000); 
}

window.startSessionTimer = startSessionTimer;

const app = createApp(App);
app.config.globalProperties.$axios = api;

app.use(router).mount('#app');